import {
  Card,
  Spin,
  Typography,
  Row,
  Icon,
  Col,
  Empty,
  DatePicker,
  Popover,
} from "antd";
import {
  Bar,
  BarChart,
  CartesianGrid,
  Legend,
  XAxis,
  YAxis,
  Line,
  LineChart,
  Tooltip,
} from "recharts";
import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { AccountService } from "../../services/account/AccountService";
import { handleError } from "../../utils/ErrorHandlers";
import Page from "../general/Page";
import withSharedStateConsumer from "../../contexts/shared-state/withSharedStateConsumer";
import ResponsiveContainer from "recharts/lib/component/ResponsiveContainer";
import moment from "moment";
import { Translation } from "react-i18next";
import i18next from "i18next";
import ar from "antd/es/date-picker/locale/ar_EG";
import en from "antd/es/date-picker/locale/en_US";
import InvalidSessionError from "../../utils/InvalidSessionError";
import { tr } from "date-fns/locale";

const { RangePicker } = DatePicker;

class AdminDashboard extends Component {
  constructor(props) {
    super(props);
    this.props.context.setCurrentComponent("adminDashboard");
    this.acc = new AccountService();
    this.state = {
      isFetching: false,
      data: {},
      agentsHandlingCalls: [],
      agentsMissedCalls: [],
      callsMHT: [],
      averageHandlingTime: [],
      averageWaitingTime: [],
      isFormSubmitted: true,
      accountId: this.props.context.user.accountId,
      lang:
        this.props.context.curr_lang === "ar" &&
        this.props.context.curr_dir === "rtl"
          ? "ar"
          : "en",
    };
  }

  async componentDidMount() {
    try {
      this.setState({ isFetching: true });
      let from = moment()
        .startOf("day")
        .format("YYYY-MM-DD HH:mm:ss")
        .toString();
      let to = moment().format("YYYY-MM-DD HH:mm:ss").toString();
      // let data = await this.getAdminDashboardData(
      //   this.state.accountId,
      //   from,
      //   to
      // );
      // let adminBarsData = await this.getAdminBarsData(
      //   this.state.accountId,
      //   from,
      //   to
      // );
      // let adminLineGraphsData = await this.getAdminLineGraphsData(
      //   this.state.accountId,
      //   from,
      //   to
      // );


     let [data, adminBarsData, adminLineGraphsData] = await Promise.all([
        this.getAdminDashboardData(this.state.accountId, from, to),
        this.getAdminBarsData(this.state.accountId, from, to),
        this.getAdminLineGraphsData(this.state.accountId, from, to),
      ]);


      this.setState({
        isFetching: false,
        data: data,
        agentsHandlingCalls: adminBarsData.agentsHandlingCalls,
        agentsMissedCalls: adminBarsData.agentsMissedCalls,
        callsMHT: this.generateDataDuring24hr(adminLineGraphsData.callsMHT),
        averageHandlingTime: this.generateDataDuring24hr(
          adminLineGraphsData.averageHandlingTime
        ),
        averageWaitingTime: this.generateDataDuring24hr(
          adminLineGraphsData.averageWaitingTime
        ),
      });
    } catch (e) {
      this.setState({ isFetching: false });
      handleError(e);
    }
  }
  componentDidUpdate(prevProps) {
    if (prevProps.location.key !== this.props.location.key) {
      this.componentDidMount();
    }
  }
  generateDataDuring24hr(data) {
    let result = [];
    for (let i = 0; i <= 24; i++) {
      const found = data.some((el) => el.hour == i);
      if (!found) {
        result.push({ hour: i + "", Duration: 0 });
      } else {
        let obj = data.find((o) => o.hour == i);
        obj.hour = parseInt(obj.hour);
        result.push(obj);
      }
    }
    return result;
  }

  async getAdminDashboardData(accountId, from, to) {
    try {
      let response = await this.acc.getAdminDashboardData(
        this.props.context.session_id,
        accountId,
        from,
        to
      );
      return response.ivrCustomEntityObject;
    } catch (e) {
      this.setState({ isFetching: false });
      if (e instanceof InvalidSessionError) {
        throw e;
      }
      handleError(e);
    }
  }

  customTooltipOnYourLine(e) {
    if (e.active && e.payload != null && e.payload[0] != null) {
      let payload = e.payload[0].payload;
      let val = this.extractHrs(payload["hour"]);
      let duration = this.secondsToHms(payload["Duration"]);
      return (
        <Card>
          <div
            style={{
              margin: "10px",
              alignItems: "center",
            }}
          >
            <p>{val}</p>
            <p style={{ color: "#d83a31" }}>Duration: {duration}</p>
          </div>
        </Card>
      );
    } else {
      return "";
    }
  }

  extractHrs(hr) {
    let val = 0;
    if (hr == 12) {
      val = hr + " pm";
    } else if (hr == 24) {
      val = hr - 12 + " am";
    } else if (hr < 12) {
      val = hr + " am";
    } else if (hr > 12) {
      val = hr - 12 + " pm";
    }
    return val;
  }

  secondsToHms(num) {
    let d = Number(num);
    var h = Math.floor(d / 3600);
    var m = Math.floor((d % 3600) / 60);
    var s = Math.floor((d % 3600) % 60);

    var hDisplay = h > 0 ? h + (h == 1 ? " hr, " : " hrs, ") : "";
    var mDisplay = m > 0 ? m + (m == 1 ? " min, " : " mins, ") : "";
    var sDisplay = s > 0 ? s + (s == 1 ? " sec" : " secs") : "";
    let duration = hDisplay + mDisplay + sDisplay;

    return duration ? duration : "0 sec";
  }

  async getAdminBarsData(accountId, from, to) {
    try {
      let response = await this.acc.getAdminBarsData(
        this.props.context.session_id,
        accountId,
        from,
        to
      );
      return response.ivrCustomEntityObject;
    } catch (e) {
      this.setState({ isFetching: false });
      if (e instanceof InvalidSessionError) {
        throw e;
      }
      handleError(e);
    }
  }

  async getAdminLineGraphsData(accountId, from, to) {
    try {
      let response = await this.acc.getAdminLineGraphsData(
        this.props.context.session_id,
        accountId,
        from,
        to
      );
      return response.ivrCustomEntityObject;
    } catch (e) {
      this.setState({ isFetching: false });
      if (e instanceof InvalidSessionError) {
        throw e;
      }
      handleError(e);
    }
  }

  async onOk(dates) {
    let from = dates[0].format("YYYY-MM-DD HH:mm:ss").toString();
    let to = dates[1].format("YYYY-MM-DD HH:mm:ss").toString();

    try {
      this.setState({ isFetching: true });
      // let data = await this.getAdminDashboardData(
      //   this.state.accountId,
      //   from,
      //   to
      // );
      // let adminBarsData = await this.getAdminBarsData(
      //   this.state.accountId,
      //   from,
      //   to
      // );
      // let adminLineGraphsData = await this.getAdminLineGraphsData(
      //   this.state.accountId,
      //   from,
      //   to
      // );

      let [data, adminBarsData, adminLineGraphsData] = await Promise.all([
        this.getAdminDashboardData(this.state.accountId, from, to),
        this.getAdminBarsData(this.state.accountId, from, to),
        this.getAdminLineGraphsData(this.state.accountId, from, to),
      ]);

      this.setState({
        isFetching: false,
        data: data,
        agentsHandlingCalls: adminBarsData.agentsHandlingCalls,
        agentsMissedCalls: adminBarsData.agentsMissedCalls,
        callsMHT: this.generateDataDuring24hr(adminLineGraphsData.callsMHT),
        averageHandlingTime: this.generateDataDuring24hr(
          adminLineGraphsData.averageHandlingTime
        ),
        averageWaitingTime: this.generateDataDuring24hr(
          adminLineGraphsData.averageWaitingTime
        ),
      });
    } catch (e) {
      this.setState({ isFetching: false });
      handleError(e);
    }
  }
  render() {
    let {
      isFetching,
      data,
      agentsHandlingCalls,
      agentsMissedCalls,
      callsMHT,
      averageHandlingTime,
      averageWaitingTime,
    } = this.state;
    const { Title } = Typography;
    const { Text } = Typography;

    return (
      <Translation>
        {(t) => (
          <Page title={t("Dashboard")}>
            <div>
              <Col xs={{ span: 23 }} lg={{ span: 23 }}>
                <Row
                  style={{
                    marginTop: "30px",
                    marginBottom: "20px",
                    alignItems: "center",
                    fontSize: "18px",
                  }}
                >
                  <Col xs={{ span: 24 }} lg={{ span: 12 }}>
                    <RangePicker
                      showTime={true}
                      format={"YYYY-MM-DD HH:mm:ss"}
                      onOk={(e) => this.onOk(e)}
                      placeholder={[i18next.t("from"), i18next.t("to")]}
                      defaultValue={[
                        moment().startOf("day"),
                        moment().endOf("day"),
                      ]}
                      locale={this.state.lang === "ar" ? ar : en}
                    />
                  </Col>
                </Row>
                {isFetching ? (
                  <Spin></Spin>
                ) : (
                  <div>
                    <Row gutter={24} type="flex" justify="space-around">
                      <Col xs={{ span: 24 }} lg={{ span: 4 }}>
                        <Popover content={t("Received Calls")}>
                          <Card
                            style={{
                              marginTop: "10px",
                              boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
                              marginBottom: "10px",
                            }}
                            title={
                              <span>
                                <Icon
                                  className="mirror-icon"
                                  style={
                                    this.props.context.curr_dir === "ltr" &&
                                    this.props.context.curr_lang === "en"
                                      ? { marginRight: 10, color: "#d73a31" }
                                      : { marginLeft: 10, color: "#d73a31" }
                                  }
                                  type="phone"
                                />

                                <Text
                                  style={{
                                    color: "#000000",
                                    fontSize:
                                      this.state.lang === "ar" ? 15 : 20,
                                  }}
                                >
                                  {t("Received Calls")}
                                </Text>
                              </span>
                            }
                            bordered={true}
                            headStyle={{ height: 40 }}
                          >
                            <p style={{ marginLeft: 25, marginTop: 5 }}>
                              <p>
                                <Title
                                  style={{ fontSize: 25, textAlign: "center" }}
                                >
                                  {data ? data.totalReceivedCalls : ""}
                                </Title>
                              </p>
                            </p>
                          </Card>
                        </Popover>
                      </Col>
                      <Col xs={{ span: 24 }} lg={{ span: 4 }}>
                        <Popover content={t("Answered Calls")}>
                          <Card
                            style={{
                              marginTop: "10px",
                              boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
                              marginBottom: "10px",
                            }}
                            title={
                              <span>
                                <Icon
                                  className="mirror-icon"
                                  style={
                                    this.props.context.curr_dir === "ltr" &&
                                    this.props.context.curr_lang === "en"
                                      ? { marginRight: 10, color: "#d73a31" }
                                      : { marginLeft: 10, color: "#d73a31" }
                                  }
                                  type="phone"
                                />

                                <Text
                                  style={{
                                    color: "#000000",
                                    fontSize:
                                      this.state.lang === "ar" ? 15 : 20,
                                  }}
                                >
                                  {t("Answered Calls")}
                                </Text>
                              </span>
                            }
                            bordered={true}
                            headStyle={{ height: 40 }}
                          >
                            <p style={{ marginLeft: 25, marginTop: 5 }}>
                              <p>
                                <Title
                                  style={{ fontSize: 25, textAlign: "center" }}
                                >
                                  {data ? data.totalAnsweredCalls : ""}
                                </Title>
                              </p>
                            </p>
                          </Card>
                        </Popover>
                      </Col>

                      <Col xs={{ span: 24 }} lg={{ span: 4 }}>
                        <Popover content={t("Switched Calls")}>
                          <Card
                            style={{
                              marginTop: "10px",
                              boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
                              marginBottom: "10px",
                            }}
                            title={
                              <span>
                                <Icon
                                  className="mirror-icon"
                                  style={
                                    this.props.context.curr_dir === "ltr" &&
                                    this.props.context.curr_lang === "en"
                                      ? { marginRight: 10, color: "#d73a31" }
                                      : { marginLeft: 10, color: "#d73a31" }
                                  }
                                  type="phone"
                                />

                                <Text
                                  style={{
                                    color: "#000000",
                                    fontSize:
                                      this.state.lang === "ar" ? 15 : 20,
                                  }}
                                >
                                  {t("Switched Calls")}
                                </Text>
                              </span>
                            }
                            bordered={true}
                            headStyle={{ height: 40 }}
                          >
                            <p style={{ marginLeft: 25, marginTop: 5 }}>
                              <p>
                                <Title
                                  style={{ fontSize: 25, textAlign: "center" }}
                                >
                                  {data ? data.totalSwitchedCalls : ""}
                                </Title>
                              </p>
                            </p>
                          </Card>
                        </Popover>
                      </Col>
                      <Col xs={{ span: 24 }} lg={{ span: 4 }}>
                        <Popover content={t("Agent Calls")}>
                          <Card
                            style={{
                              marginTop: "10px",
                              boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
                              marginBottom: "10px",
                            }}
                            title={
                              <span>
                                <Icon
                                  className="mirror-icon"
                                  style={
                                    this.props.context.curr_dir === "ltr" &&
                                    this.props.context.curr_lang === "en"
                                      ? { marginRight: 10, color: "#d73a31" }
                                      : { marginLeft: 10, color: "#d73a31" }
                                  }
                                  type="phone"
                                />

                                <Text
                                  style={{
                                    color: "#000000",
                                    fontSize:
                                      this.state.lang === "ar" ? 15 : 20,
                                  }}
                                >
                                  {t("Agent Calls")}
                                </Text>
                              </span>
                            }
                            bordered={true}
                            headStyle={{ height: 40 }}
                          >
                            <p style={{ marginLeft: 25, marginTop: 5 }}>
                              <p>
                                <Title
                                  style={{ fontSize: 25, textAlign: "center" }}
                                >
                                  {data ? data.totalAnsweredByAgent : ""}
                                </Title>
                              </p>
                            </p>
                          </Card>
                        </Popover>
                      </Col>
                      <Col xs={{ span: 24 }} lg={{ span: 4 }}>
                        <Popover content={t("Voicemail Calls")}>
                          <Card
                            style={{
                              marginTop: "10px",
                              boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
                              marginBottom: "10px",
                            }}
                            title={
                              <span>
                                <Icon
                                  className="mirror-icon"
                                  style={
                                    this.props.context.curr_dir === "ltr" &&
                                    this.props.context.curr_lang === "en"
                                      ? { marginRight: 10, color: "#d73a31" }
                                      : { marginLeft: 10, color: "#d73a31" }
                                  }
                                  type="phone"
                                />

                                <Text
                                  style={{
                                    color: "#000000",
                                    fontSize:
                                      this.state.lang === "ar" ? 15 : 20,
                                  }}
                                >
                                  {t("Voicemail Calls")}
                                </Text>
                              </span>
                            }
                            bordered={true}
                            headStyle={{ height: 40 }}
                          >
                            <p style={{ marginLeft: 25, marginTop: 5 }}>
                              <p>
                                <Title
                                  style={{ fontSize: 25, textAlign: "center" }}
                                >
                                  {data ? data.totalAnsweredVoiceMail : ""}
                                </Title>
                              </p>
                            </p>
                          </Card>
                        </Popover>
                      </Col>
                    </Row>
                    {/* <Row gutter={24}></Row> */}
                    <Row gutter={24} type="flex" justify="space-around">
                      <Col xs={{ span: 24 }} lg={{ span: 12 }}>
                        <Card
                          style={{
                            marginTop: "10px",
                            // padding: "0px 30px 10px 10px",
                            boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
                            marginBottom: "10px",
                          }}
                          bordered={false}
                          title={
                            <span style={{ color: "rgba(0, 0, 0, 0.65)" }}>
                              <Icon
                                type="bar-chart"
                                style={{ margin: "10px", color: "#d73a31" }}
                              />
                              <Text
                                style={{
                                  color: "#000000",
                                  fontSize: this.state.lang === "ar" ? 15 : 20,
                                }}
                              >
                                {t("Top 5 Agents Handling calls")}
                              </Text>
                            </span>
                          }
                          headStyle={{
                            backgroundColor: "rgba(255, 255, 255, 0.4)",
                            border: 0,
                            height: 10,
                          }}
                        >
                          <ResponsiveContainer width="100%" height={250}>
                            {agentsHandlingCalls.length !== 0 ? (
                              <BarChart
                                style={
                                  this.props.context.curr_dir === "rtl"
                                    ? { direction: "ltr" }
                                    : { direction: "ltr" }
                                }
                                data={agentsHandlingCalls}
                                margin={
                                  this.props.context.curr_dir === "ltr" &&
                                  this.props.context.curr_lang === "en"
                                    ? {
                                        top: 20,
                                        right: 30,
                                        left: 20,
                                        bottom: 5,
                                      }
                                    : {
                                        top: 20,
                                        left: 30,
                                        right: 20,
                                        bottom: 5,
                                      }
                                }
                              >
                                <XAxis
                                  dataKey="user_fullname"
                                  strokeWidth={0}
                                  reversed={
                                    this.props.context.curr_dir === "rtl"
                                      ? true
                                      : false
                                  }
                                />
                                <YAxis
                                  strokeWidth={0}
                                  orientation={
                                    this.props.context.curr_dir === "rtl"
                                      ? "right"
                                      : "left"
                                  }
                                />
                                <CartesianGrid strokeDasharray="3 3" />
                                <Tooltip />
                                <Legend />
                                <Bar
                                  dataKey="Handling calls"
                                  fill="#d73a31"
                                  radius={3}
                                  barSize={35}
                                  name={t("Handling calls")}
                                />
                              </BarChart>
                            ) : (
                              <Empty
                                description={i18next.t("Empty")}
                                image={Empty.PRESENTED_IMAGE_SIMPLE}
                              />
                            )}
                          </ResponsiveContainer>
                        </Card>
                      </Col>
                      <Col xs={{ span: 24 }} lg={{ span: 12 }}>
                        <Card
                          style={{
                            // padding: "0px 30px 10px 10px",
                            marginTop: "10px",
                            boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
                            marginBottom: "10px",
                          }}
                          bordered={false}
                          title={
                            <span style={{ color: "rgba(0, 0, 0, 0.65)" }}>
                              <Icon
                                type="bar-chart"
                                style={{ margin: "10px", color: "#d73a31" }}
                              />
                              <Text
                                style={{
                                  color: "#000000",
                                  fontSize: this.state.lang === "ar" ? 15 : 20,
                                }}
                              >
                                {t("Calls Missed From Agents")}
                              </Text>
                            </span>
                          }
                          headStyle={{
                            backgroundColor: "rgba(255, 255, 255, 0.4)",
                            border: 0,
                            height: 10,
                          }}
                        >
                          <ResponsiveContainer width="100%" height={250}>
                            {agentsMissedCalls.length !== 0 ? (
                              <BarChart
                                style={
                                  this.props.context.curr_dir === "rtl"
                                    ? { direction: "ltr" }
                                    : { direction: "ltr" }
                                }
                                data={agentsMissedCalls}
                                margin={
                                  this.props.context.curr_dir === "ltr" &&
                                  this.props.context.curr_lang === "en"
                                    ? {
                                        top: 20,
                                        right: 30,
                                        left: 20,
                                        bottom: 5,
                                      }
                                    : {
                                        top: 20,
                                        left: 30,
                                        right: 20,
                                        bottom: 5,
                                      }
                                }
                              >
                                <XAxis
                                  dataKey="user_fullname"
                                  strokeWidth={0}
                                  reversed={
                                    this.props.context.curr_dir === "rtl"
                                      ? true
                                      : false
                                  }
                                />
                                <YAxis
                                  strokeWidth={0}
                                  orientation={
                                    this.props.context.curr_dir === "rtl"
                                      ? "right"
                                      : "left"
                                  }
                                />
                                <CartesianGrid strokeDasharray="3 3" />
                                <Tooltip />
                                <Legend />
                                <Bar
                                  dataKey="Missed calls"
                                  fill="#d73a31"
                                  radius={3}
                                  barSize={35}
                                  name={t("Missed calls")}
                                />
                              </BarChart>
                            ) : (
                              <Empty
                                description={i18next.t("Empty")}
                                image={Empty.PRESENTED_IMAGE_SIMPLE}
                              />
                            )}
                          </ResponsiveContainer>
                        </Card>
                      </Col>
                    </Row>

                    <Row gutter={24}>
                      <Col xs={{ span: 24 }} lg={{ span: 24 }}>
                        <Card
                          style={
                            this.props.context.curr_dir === "ltr" &&
                            this.props.context.curr_lang === "en"
                              ? {
                                  padding: "0px 30px 10px 10px",
                                  marginTop: "10px",
                                  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
                                  marginBottom: "10px",
                                }
                              : {
                                  padding: "0px 10px 10px 30px",
                                  marginTop: "10px",
                                  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
                                  marginBottom: "10px",
                                }
                          }
                          bordered={false}
                          title={
                            <span style={{ color: "rgba(0, 0, 0, 0.65)" }}>
                              <Icon
                                type="line-chart"
                                style={{ margin: "10px", color: "#d73a31" }}
                              />
                              <Text
                                style={{
                                  color: "#000000",
                                  fontSize: this.state.lang === "ar" ? 15 : 20,
                                }}
                              >
                                {t("MHT For The Calls")}
                              </Text>
                            </span>
                          }
                          headStyle={{
                            backgroundColor: "rgba(255, 255, 255, 0.4)",
                            border: 0,
                            height: 10,
                            marginBottom: 10,
                          }}
                        >
                          <ResponsiveContainer width="100%" height={250}>
                            {callsMHT.length !== 0 ? (
                              <LineChart
                                data={callsMHT}
                                style={
                                  this.props.context.curr_dir === "rtl"
                                    ? { direction: "ltr" }
                                    : { direction: "ltr" }
                                }
                              >
                                <CartesianGrid strokeDasharray="3 3" />
                                <XAxis
                                  dataKey="hour"
                                  strokeWidth={0}
                                  reversed={
                                    this.props.context.curr_dir === "rtl"
                                      ? true
                                      : false
                                  }
                                />
                                <YAxis
                                  strokeWidth={0}
                                  unit="sec"
                                  orientation={
                                    this.props.context.curr_dir === "rtl"
                                      ? "right"
                                      : "left"
                                  }
                                />
                                <Tooltip
                                  content={(e) =>
                                    this.customTooltipOnYourLine(e)
                                  }
                                />
                                <Line
                                  strokeWidth={2}
                                  dataKey="Duration"
                                  stroke="#d73a31"
                                  activeDot={{ r: 8 }}
                                />
                              </LineChart>
                            ) : (
                              <Empty
                                description={i18next.t("Empty")}
                                image={Empty.PRESENTED_IMAGE_SIMPLE}
                              />
                            )}
                          </ResponsiveContainer>
                        </Card>
                      </Col>
                    </Row>

                    <Row gutter={24}>
                      <Col xs={{ span: 24 }} lg={{ span: 24 }}>
                        <Card
                          style={
                            this.props.context.curr_dir === "ltr" &&
                            this.props.context.curr_lang === "en"
                              ? {
                                  padding: "0px 30px 10px 10px",
                                  marginTop: "10px",
                                  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
                                  marginBottom: "10px",
                                }
                              : {
                                  padding: "0px 10px 10px 30px",
                                  marginTop: "10px",
                                  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
                                  marginBottom: "10px",
                                }
                          }
                          bordered={false}
                          title={
                            <span style={{ color: "rgba(0, 0, 0, 0.65)" }}>
                              <Icon
                                type="line-chart"
                                style={{ margin: "10px", color: "#d73a31" }}
                              />
                              <Text
                                style={{
                                  color: "#000000",
                                  fontSize: this.state.lang === "ar" ? 15 : 20,
                                }}
                              >
                                {t("Average Handling Time")}
                              </Text>
                            </span>
                          }
                          headStyle={{
                            backgroundColor: "rgba(255, 255, 255, 0.4)",
                            border: 0,
                            height: 10,
                            marginBottom: 10,
                          }}
                        >
                          <ResponsiveContainer width="100%" height={250}>
                            {averageHandlingTime.length !== 0 ? (
                              <LineChart
                                data={averageHandlingTime}
                                style={
                                  this.props.context.curr_dir === "rtl"
                                    ? { direction: "ltr" }
                                    : { direction: "ltr" }
                                }
                              >
                                <CartesianGrid strokeDasharray="3 3" />
                                <XAxis
                                  dataKey="hour"
                                  strokeWidth={0}
                                  reversed={
                                    this.props.context.curr_dir === "rtl"
                                      ? true
                                      : false
                                  }
                                />
                                <YAxis
                                  strokeWidth={0}
                                  unit="sec"
                                  orientation={
                                    this.props.context.curr_dir === "rtl"
                                      ? "right"
                                      : "left"
                                  }
                                />
                                <Tooltip
                                  content={(e) =>
                                    this.customTooltipOnYourLine(e)
                                  }
                                />{" "}
                                <Line
                                  strokeWidth={2}
                                  dataKey="Duration"
                                  stroke="#d73a31"
                                  activeDot={{ r: 8 }}
                                />
                              </LineChart>
                            ) : (
                              <Empty
                                description={i18next.t("Empty")}
                                image={Empty.PRESENTED_IMAGE_SIMPLE}
                              />
                            )}
                          </ResponsiveContainer>
                        </Card>
                      </Col>
                    </Row>

                    <Row gutter={24}>
                      <Col xs={{ span: 24 }} lg={{ span: 24 }}>
                        <Card
                          style={
                            this.props.context.curr_dir === "ltr" &&
                            this.props.context.curr_lang === "en"
                              ? {
                                  padding: "0px 30px 10px 10px",
                                  marginTop: "10px",
                                  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
                                  marginBottom: "10px",
                                }
                              : {
                                  padding: "0px 10px 10px 30px",
                                  marginTop: "10px",
                                  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
                                  marginBottom: "10px",
                                }
                          }
                          bordered={false}
                          title={
                            <span style={{ color: "rgba(0, 0, 0, 0.65)" }}>
                              <Icon
                                type="line-chart"
                                style={{ margin: "10px", color: "#d73a31" }}
                              />
                              <Text
                                style={{
                                  color: "#000000",
                                  fontSize: this.state.lang === "ar" ? 15 : 20,
                                }}
                              >
                                {t("Average Waiting Time")}
                              </Text>
                            </span>
                          }
                          headStyle={{
                            backgroundColor: "rgba(255, 255, 255, 0.4)",
                            border: 0,
                            height: 10,
                            marginBottom: 10,
                          }}
                        >
                          <ResponsiveContainer width="100%" height={250}>
                            {averageWaitingTime.length !== 0 ? (
                              <LineChart
                                data={averageWaitingTime}
                                style={
                                  this.props.context.curr_dir === "rtl"
                                    ? { direction: "ltr" }
                                    : { direction: "ltr" }
                                }
                              >
                                <CartesianGrid strokeDasharray="3 3" />
                                <XAxis
                                  dataKey="hour"
                                  strokeWidth={0}
                                  reversed={
                                    this.props.context.curr_dir === "rtl"
                                      ? true
                                      : false
                                  }
                                />
                                <YAxis
                                  strokeWidth={0}
                                  unit="sec"
                                  orientation={
                                    this.props.context.curr_dir === "rtl"
                                      ? "right"
                                      : "left"
                                  }
                                />
                                <Tooltip
                                  content={(e) =>
                                    this.customTooltipOnYourLine(e)
                                  }
                                />{" "}
                                <Line
                                  strokeWidth={2}
                                  dataKey="Duration"
                                  stroke="#d73a31"
                                  activeDot={{ r: 8 }}
                                />
                              </LineChart>
                            ) : (
                              <Empty
                                description={i18next.t("Empty")}
                                image={Empty.PRESENTED_IMAGE_SIMPLE}
                              />
                            )}
                          </ResponsiveContainer>
                        </Card>
                      </Col>
                    </Row>
                  </div>
                )}
              </Col>
            </div>
          </Page>
        )}
      </Translation>
    );
  }
}

export default withSharedStateConsumer(withRouter(AdminDashboard));
